'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/react-treebeard/index.js
// module id = 3483
// module chunks = 4